import React from "react"
import styled from "styled-components"
import FeatureIcon from "./FeatureIcon"
import FillIcon from "./FillIcon"
import { SECONDARY_TEXT } from "./consts/colors"
import storefront from "../assets/svgs/storefront.svg"

import AddtoSlack from "./AddtoSlack"

const FeatureCardWrapper = styled.div`
  background-color: white;
  display: flex;
  justify-content: center;
  overflow: hidden;
  margin: 0 auto;
  width: 100%;
  max-width: 1200px;
  border-radius: 18px;
  box-shadow: 0px 7px 15px ${SECONDARY_TEXT};
  background-image: url(${storefront});
  background-position: 70% 90%;
  background-size: 100%;
  background-repeat: no-repeat;

  @media (max-width: 768px) {
    margin-bottom: 40px;
  }

  @media (max-width: 615px) {
    width: 95%;
    background-size: 140%;
  }
`

const FeatureCardContent = styled.div`
  display: flex;
  width: 600px;
  text-align: center;
  margin: 50px 0px 100px 0px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px 0px;
  padding-right: 5px;

  @media (max-width: 480px) {
    margin: 10px 0px 20px 0px;
    padding: 5px;
  }
`
const FeatureCardIcon = styled.div`
  transform: scale(1.2);
  margin: 20px;
  padding: 8px;
  position: relative;

  @media (max-width: 480px) {
    transform: scale(0.9);
    margin: 5px;
    padding: 3px;
  }
`

const FeatureCardTitle = styled.h3``

const FeatureCardButton = styled.div`
  margin-top: 40px;
  height: 40px;

  @media (max-width: 480px) {
    margin-top: 20px;
  }
`

const FeatureCard = props => (
  <FeatureCardWrapper>
    <FeatureCardContent>
      <FeatureCardIcon>
        <FillIcon name={props.name} />
      </FeatureCardIcon>
      <FeatureCardTitle>{props.title}</FeatureCardTitle>
      <FeatureCardButton>
        <AddtoSlack />
      </FeatureCardButton>
    </FeatureCardContent>
  </FeatureCardWrapper>
)

export default FeatureCard



// WEBPACK FOOTER //
// ./src/components/FeatureCard.js